import { Node_Type } from 'ricos-types';
import classNames from 'classnames';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { RicosNodeContext, RicosAlignmentContextProvider, RicosNodeContextProvider, RicosContext } from 'ricos-context';
import '@tiptap/core';
import 'ricos-content';
import 'ricos-plugins';
import { CollapsibleListData_InitialExpandedItems } from 'ricos-schema';
import { anchorScroll } from 'wix-rich-content-common';

const DEFAULTS = Object.freeze({
  config: {
    initialExpandedItems: "FIRST",
    expandOnlyOne: false
  }
});

const COLLAPSIBLE_LIST_TYPE = "wix-rich-content-plugin-collapsible-list";

var collapsibleListItemStyles = {"container":"Oq-zn","title":"uUbUv","viewerContainer":"aQGQT","titleContainer":"-VX-Z","content":"_42jv-","expandIcon":"U9kU4","dndIcon":"TQwzd","RTL":"iQgJ5","LTR":"wMd0w","itemContainer":"_2GtAh","itemContainerViewer":"E5PSA","mouseDown":"RiNS-","innerEditor":"_0IjNM","item":"orkP5","floatingAddPluginMenuWrapper":"B4SoJ"};

const getAlignmentFromDirection = (direction) => direction.toLowerCase() === "rtl" ? "right" : direction.toLowerCase() === "ltr" ? "left" : void 0;

var __defProp$4 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CollapsibleListItemProperty = ({
  node,
  RicosNodesRenderer,
  type
}) => {
  var _a, _b;
  const { parentNode } = useContext(RicosNodeContext);
  const parentNodeDirection = (_a = parentNode == null ? void 0 : parentNode.collapsibleListData) == null ? void 0 : _a.direction;
  const listAlignment = parentNodeDirection ? getAlignmentFromDirection(parentNodeDirection) : void 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(
        collapsibleListItemStyles.container,
        collapsibleListItemStyles.viewerContainer,
        type === "title" ? collapsibleListItemStyles.titleContainer : null,
        collapsibleListItemStyles.innerEditor
      )
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: "100%",
          textAlign: listAlignment
        }
      },
      /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_b = node.nodes) != null ? _b : [], shouldParagraphApplyTextStyle: true })
    )
  );
};
const CollapsibleListItemTitleProperty = (_a) => {
  var _b = _a, { node } = _b, props = __objRest$2(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, __spreadProps(__spreadValues$4({ key: node.id, node }, props), { type: "title" }));
};
const CollapsibleListItemBodyProperty = (_c) => {
  var _d = _c, { node } = _d, props = __objRest$2(_d, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, __spreadProps(__spreadValues$4({ key: node.id, node }, props), { type: "body" }));
};

var styles = {"ltr":"iFJyz","rtl":"sARdk","iconContainer":"JXTBe","icon":"uh6VN","isExpanded":"AOhpq","listDimensions":"-TPlK"};

const ROOT = "collapsibleListComponent";

const CollapsibleListContext = React.createContext(
  null
);
const CollapsibleListContextProvider = ({
  expandedItemId,
  setExpandedItemId,
  children
}) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListContext.Provider, { value: { expandedItemId, setExpandedItemId } }, children);
};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CollapsibleList = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  var _a, _b;
  const [expandedItemId, setExpandedItemId] = useState(void 0);
  const styles$1 = styles;
  const direction = ((_a = node.collapsibleListData) == null ? void 0 : _a.direction.toLowerCase()) || "ltr";
  const alignment = getAlignmentFromDirection(direction);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles$1[direction], styles$1.listDimensions), "data-hook": ROOT }, /* @__PURE__ */ React.createElement(RicosAlignmentContextProvider, { textAlignment: alignment }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(
    CollapsibleListContextProvider,
    {
      expandedItemId,
      setExpandedItemId
    },
    /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_b = node.nodes) != null ? _b : [] })
  )))));
};
const CollapsibleListRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest$1(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleList, __spreadValues$3({ key: node.id, node }, props));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const ArrowIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$2({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.999 9L6 14.241 6.657 15 11.999 10.334 17.343 15 18 14.241z",
    transform: "translate(-129 -185) translate(97 105) translate(23 71) rotate(-90 21 12) matrix(1 0 0 -1 0 24)"
  }
)))))));

const ExpandCollapseButton = (props) => {
  const { onClick, idx, ariaLabel } = props;
  return (
    //using 'div' element instead of 'button' to fix a bug of focus on element in Firefox in OSX
    // further reading, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus#Clicking_and_focus
    /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "button",
        tabIndex: -1,
        className: styles.iconContainer,
        onClick,
        onKeyUp: (e) => (e.key === " " || e.key === "Enter") && onClick(e),
        "data-hook": `ExpandCollapseButton_${idx} collapsibleListExpandButton`
      },
      /* @__PURE__ */ React.createElement(
        ArrowIcon,
        {
          role: "button",
          tabIndex: "0",
          "aria-label": ariaLabel,
          className: classNames(styles.icon, props.isExpanded && styles.isExpanded)
        }
      )
    )
  );
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CollapsibleListItem = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b;
  const { parentNode } = useContext(RicosNodeContext);
  const { expandedItemId, setExpandedItemId } = useContext(CollapsibleListContext);
  const containerRef = useRef(null);
  const { initialExpandedItems, expandOnlyOne } = (parentNode == null ? void 0 : parentNode.collapsibleListData) || {};
  const [isExpanded, setIsExpanded] = useState(
    CollapsibleListData_InitialExpandedItems.ALL === initialExpandedItems || nodeIndex === 0 && CollapsibleListData_InitialExpandedItems.FIRST === initialExpandedItems
  );
  const { t } = useContext(RicosContext);
  const styles = collapsibleListItemStyles;
  const toggleCollapsibleListBody = () => {
    setIsExpanded((prev) => !prev);
    setExpandedItemId(node.id);
    anchorScroll(containerRef.current);
  };
  useEffect(() => {
    if (expandOnlyOne && expandedItemId && expandedItemId !== node.id) {
      setIsExpanded(false);
    }
  }, [expandedItemId]);
  const allChilrenList = (_a = node.nodes) != null ? _a : [];
  const firstChildList = ((_b = node.nodes) == null ? void 0 : _b[0]) ? [node.nodes[0]] : [];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.itemContainer, styles.itemContainerViewer),
      ref: containerRef
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.expandIcon }, /* @__PURE__ */ React.createElement(
      ExpandCollapseButton,
      {
        isExpanded,
        onClick: toggleCollapsibleListBody,
        ariaLabel: isExpanded ? t("CollapsibleListPlugin_ExpandButton_AriaLabel") : t("CollapsibleListPlugin_CollapseButton_AriaLabel")
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: styles.item }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: isExpanded ? allChilrenList : firstChildList }))
  ));
};
const CollapsibleListItemRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleListItem, __spreadValues$1({ key: node.id, node }, props));
};

const nodeViewRenderers = {
  [Node_Type.COLLAPSIBLE_LIST]: CollapsibleListRenderer,
  [Node_Type.COLLAPSIBLE_ITEM]: CollapsibleListItemRenderer,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: CollapsibleListItemTitleProperty,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: CollapsibleListItemBodyProperty
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginCollapsibleList = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: COLLAPSIBLE_LIST_TYPE,
    nodeViewRenderers
  };
};

export { COLLAPSIBLE_LIST_TYPE, pluginCollapsibleList };
//# sourceMappingURL=viewer.js.map
